import React from "react";

type Props = {};

const ApplicationHistory = (props: Props) => {
  return <div>ApplicationHistory</div>;
};

export default ApplicationHistory;
